import { render, staticRenderFns } from "./FluxI2I.vue?vue&type=template&id=c9db0094&scoped=true"
import script from "./FluxI2I.vue?vue&type=script&lang=js"
export * from "./FluxI2I.vue?vue&type=script&lang=js"
import style0 from "./FluxI2I.vue?vue&type=style&index=0&id=c9db0094&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9db0094",
  null
  
)

export default component.exports